/* tslint:disable */
import {
  TenantPayments,
  IncomeInvoice,
  PropertySettlement
} from '../index';

declare var Object: any;
export interface InvoicePaymentEntryInterface {
  "invoice_id": number;
  "lease_id": number;
  "tenant_payment_id": number;
  "amount_paid": number;
  "property_settlement_id"?: number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  tenantPayments?: TenantPayments;
  incomeInvoice?: IncomeInvoice;
  propertySettlement?: PropertySettlement;
}

export class InvoicePaymentEntry implements InvoicePaymentEntryInterface {
  "invoice_id": number;
  "lease_id": number;
  "tenant_payment_id": number;
  "amount_paid": number;
  "property_settlement_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  tenantPayments: TenantPayments;
  incomeInvoice: IncomeInvoice;
  propertySettlement: PropertySettlement;
  constructor(data?: InvoicePaymentEntryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InvoicePaymentEntry`.
   */
  public static getModelName() {
    return "InvoicePaymentEntry";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InvoicePaymentEntry for dynamic purposes.
  **/
  public static factory(data: InvoicePaymentEntryInterface): InvoicePaymentEntry{
    return new InvoicePaymentEntry(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InvoicePaymentEntry',
      plural: 'InvoicePaymentEntries',
      path: 'InvoicePaymentEntries',
      idName: 'id',
      properties: {
        "invoice_id": {
          name: 'invoice_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "tenant_payment_id": {
          name: 'tenant_payment_id',
          type: 'number'
        },
        "amount_paid": {
          name: 'amount_paid',
          type: 'number'
        },
        "property_settlement_id": {
          name: 'property_settlement_id',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        tenantPayments: {
          name: 'tenantPayments',
          type: 'TenantPayments',
          model: 'TenantPayments',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_payment_id',
          keyTo: 'id'
        },
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'belongsTo',
                  keyFrom: 'invoice_id',
          keyTo: 'id'
        },
        propertySettlement: {
          name: 'propertySettlement',
          type: 'PropertySettlement',
          model: 'PropertySettlement',
          relationType: 'belongsTo',
                  keyFrom: 'property_settlement_id',
          keyTo: 'id'
        },
      }
    }
  }
}
